import { create } from 'zustand';

/**
 * Transient app-shell UI state for chrome shared across screens. Headers are
 * pinned (`sticky top-0`) on every screen, so there is no collapse signal.
 */
interface UiState {
  navDrawerOpen: boolean;
  setNavDrawerOpen: (open: boolean) => void;
  openNavDrawer: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  navDrawerOpen: false,
  setNavDrawerOpen: (navDrawerOpen) => set({ navDrawerOpen }),
  openNavDrawer: () => set({ navDrawerOpen: true }),
}));
